import { NetworkError } from '@/errors';
import { addMetric, createException, createWarning } from '@/utils/monitoring.utils';

export const handleError = (error: Error) => {
  if (error instanceof NetworkError) {
    createWarning(error);
    addMetric('cancellations-table', { status: 'network_error', channel: 'merchant' });
  } else {
    createException(error);
    addMetric('cancellations-table', { status: 'error', channel: 'merchant' });
  }
};
